"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _RadioIcon = _interopRequireDefault(require("./RadioIcon"));
var _styled = require("../styled");
var _excluded = ["testId", "name", "isChecked", "isDisabled", "isFocused", "isHovered", "isPressed", "hasLabel", "onBlur", "onChange", "onClick", "onFocus", "onMouseEnter", "onMouseLeave"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RadioInput = function RadioInput(_ref) {
  var testId = _ref.testId,
    name = _ref.name,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isHovered = _ref.isHovered,
    isPressed = _ref.isPressed,
    hasLabel = _ref.hasLabel,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styled.RadioInputWrapper, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/_react["default"].createElement(_RadioIcon["default"], {
    hasLabel: hasLabel,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocused: isFocused,
    isHovered: isHovered,
    isPressed: isPressed
  }), /*#__PURE__*/_react["default"].createElement(_styled.RadioInputField, _extends({}, (0, _oxygenConfig.getTestAttributes)(testId), rest, {
    name: name,
    type: "radio",
    checked: isChecked,
    "aria-disabled": isDisabled,
    onClick: onClick,
    onChange: !isDisabled ? onChange : null,
    onFocus: onFocus,
    onBlur: onBlur
  })));
};
RadioInput.propTypes = {
  testId: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  isChecked: _propTypes["default"].bool.isRequired,
  isDisabled: _propTypes["default"].bool.isRequired,
  isFocused: _propTypes["default"].bool.isRequired,
  isHovered: _propTypes["default"].bool.isRequired,
  isPressed: _propTypes["default"].bool.isRequired,
  hasLabel: _propTypes["default"].bool.isRequired,
  onBlur: _propTypes["default"].func.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func.isRequired,
  onMouseEnter: _propTypes["default"].func.isRequired,
  onMouseLeave: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = RadioInput;